import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CalendarComponent from '../../components/calendar/CalendarComponent';

function CalendarPage() {
  const { t } = useTranslation();

  return (
    <Container fluid className='py-4'>
      <Row>
        <Col>
          <h2 className='mb-4'>{t('sidebar.items.calendar')}</h2>
          <CalendarComponent />
        </Col>
      </Row>
    </Container>
  );
}

export default CalendarPage;
